/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Sub_Quotas_Show_AllInputs */



/**
* | output |
* | --- |
* | "Show all {count} members" |
*
* @param {Sub_Quotas_Show_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_quotas_show_all = /** @type {((inputs: Sub_Quotas_Show_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Quotas_Show_AllInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Alle ${i?.count} Mitglieder anzeigen`)
	return /** @type {LocalizedString} */ (`Show all ${i?.count} members`)
});